import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { EnergyType } from '@essent/new-customer';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { ComponentFields, JssModule } from '@sitecore-jss/sitecore-jss-angular';

import { PriceOverviewTableComponent } from './price-overview-table/price-overview-table.component';

@Component({
  selector: 'wl-aom-cost-table',
  templateUrl: './aom-cost-table.component.html',
  styleUrls: [
    './aom-cost-table.component.ed.scss',
    './aom-cost-table.component.essent.scss',
  ],
  standalone: true,
  imports: [CommonModule, PriceOverviewTableComponent, JssModule],
})
export class AomCostTableComponent {
  readonly fields = input.required<ComponentFields>();
  readonly rendering = input<InnogyComponentRendering>();
  readonly offer = input<Offer>();
  readonly hasDiscount = input<boolean>();
  readonly enableRemoveBBA = input<boolean | undefined | null>(false);

  get electricityOverview() {
    return this.offer()?.offerOverviews.find(
      (o) => o.energyType === EnergyType.ELECTRICITY
    );
  }

  get gasOverview() {
    return this.offer()?.offerOverviews.find(
      (o) => o.energyType === EnergyType.GAS
    );
  }
}
